export default __webpack_public_path__ + "static/media/CPASAGE_Client home page icons-14.4cc07cd6.svg";